import { buildThreadKeyFromDeal } from "./dealLensThreadCacheKey";
import { resolvePropertyOfferDeallensId } from "./propertyOfferUtils";

/**
 * Picks the deal row DealLens detail should treat as authoritative while route/detail
 * resolution is still in flight. Location.state bootstrap fills gaps when the loaded
 * deal belongs to a different thread than the row the user clicked.
 *
 * @param {object | null | undefined} deal
 * @param {object | null | undefined} propertyOfferBootstrap
 * @returns {object | null | undefined}
 */
export function resolveDetailDealWithBootstrap(deal, propertyOfferBootstrap) {
  if (!propertyOfferBootstrap) return deal;

  const bootstrapCollectionId = String(propertyOfferBootstrap?.collection_id ?? "").trim();
  const bootstrapDeallensId = resolvePropertyOfferDeallensId(propertyOfferBootstrap);

  if (!deal) return propertyOfferBootstrap;

  const loadedCollectionId = String(deal?.collection_id ?? "").trim();
  const loadedDeallensId = resolvePropertyOfferDeallensId(deal);
  const collectionMatches =
    bootstrapCollectionId && loadedCollectionId && bootstrapCollectionId === loadedCollectionId;
  const deallensMatches =
    bootstrapDeallensId && loadedDeallensId && bootstrapDeallensId === loadedDeallensId;
  const sameThread =
    buildThreadKeyFromDeal(deal) &&
    buildThreadKeyFromDeal(deal) === buildThreadKeyFromDeal(propertyOfferBootstrap);

  if (collectionMatches || deallensMatches) return deal;

  // Property-offer rows are keyed by collection_id; a same-thread API tip must not override a different row.
  if (bootstrapCollectionId) return propertyOfferBootstrap;

  if (sameThread) return deal;
  return propertyOfferBootstrap;
}
